module.exports = __webpack_public_path__ + "verizon-2015.svg";